module.exports = __webpack_public_path__ + "img/vodafone-red-bg.e75170a6.jpg";